import React, { useEffect, useState } from "react";

import NextImage from "../common/NextImage";
import { teamLeagueInfoUrl } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";

const CricketStandings = ({
  ServerData,
  loadCSS = true,
  dataClient = false,
  title,
  websiteBaseUrl,
  dataPath,
  sport = "cricket",
  dictionary = {},
}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData;

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketmatch");
    }
  }, [loadCSS]);
  return (
    <>
      {title ? <h1>{title}</h1> : null}
      <div className="global_table cr_standing_table">
        {data?.data?.length > 0 ? (
          data?.data?.map((group, groupIndex) => (
            <div key={groupIndex}>
              <h2 className="cr_title">
                {data.data.length < 2
                  ? ""
                  : group[0]?.grp ?? `Group ${groupIndex + 1}`}
              </h2>{" "}
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      <span>{dictionary?.teams || "Teams"}</span>
                    </th>
                    <th>MP</th>
                    <th>W</th>
                    <th>D</th>
                    <th>L</th>
                    <th>TP</th>
                    <th>PTS</th>
                    <th>{dictionary?.form || "FORM"}</th>
                  </tr>
                </thead>
                <tbody>
                  {group.map((team, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a
                          href={teamLeagueInfoUrl({
                            dataClient,
                            websiteBaseUrl,
                            dataPath,
                            category: "team",
                            sport,
                            name: team?.tnm,
                            id: team?.tid,
                          })}
                          className="team_name"
                        >
                          <div className="bolar_team">
                            <div className="ico_flag">
                              <NextImage
                                src={`https://cric.livescoring.cc/teamflags/${team?.tid}.png`}
                                width={22}
                                height={22}
                                key={team?.tid}
                              />
                            </div>
                            <span className="name">{team?.tnm}</span>
                          </div>
                        </a>
                      </td>
                      <td>{team?.mt}</td>
                      <td>{team?.wo}</td>
                      <td>{team?.dr}</td>
                      <td>{team?.lo}</td>
                      <td>{team?.pos}</td>
                      <td>{team?.pts}</td>
                      <td>
                        <ul className="prev_match_status">
                          {team?.prem?.map((w, i) => (
                            <li
                              key={i}
                              className={
                                w === "W" ? "win" : w === "D" ? "draw" : "loss"
                              }
                            >
                              {w}
                            </li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))
        ) : (
          <p>No data Found...</p>
        )}
      </div>
    </>
  );
};

export default CricketStandings;
